import { SVGProps } from "react"

const Calendar2Icon = (props: SVGProps<SVGSVGElement>) => (
  <>
    <svg
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.667 3.33337H3.33366C2.96547 3.33337 2.66699 3.63185 2.66699 4.00004V17.3334C2.66699 17.7016 2.96547 18 3.33366 18H16.667C17.0352 18 17.3337 17.7016 17.3337 17.3334V4.00004C17.3337 3.63185 17.0352 3.33337 16.667 3.33337Z"
        stroke={props.stroke || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V4.66667"
        stroke={props.stroke || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2V4.66667"
        stroke={props.stroke || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66699 7.33337H17.3337"
        stroke={props.stroke || "white"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </>
)
export default Calendar2Icon
